/**
 * Created with JetBrains WebStorm.
 * Invoice: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('Invoice_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/invoices/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'},
        payIn: {method: 'POST', url: baseUrl + 'rest/invoices/payIn'},
        updateVat: {method: 'POST', url: baseUrl + 'rest/invoices/updateVat'},
        generateInvoiceOnPreviousMonth: {method: 'POST', url: baseUrl + 'rest/invoices/generate-monthly?month=:previousMonthNumber'},
        generateEstimateInvoice: {method: 'POST', url: baseUrl + 'rest/invoices/generateEstimateInvoice'},
        proceedPayment: {method: 'POST', url: baseUrl + 'rest/invoices/proceedPayment'},
        cancel: {method: 'POST', url: baseUrl + 'rest/invoices/cancel'},
        globalPayOut: {method: 'POST', url: baseUrl + 'rest/invoices/globalPayOut'},
    });
}
]);

angular.module('FlexyBeautyApp.services').factory('Invoice', ["Invoice_Resource", "StoreAppData", "InvoiceData", "Countries",
    function (Invoice_Resource, StoreAppData, InvoiceData, Countries) {
        //Invoice inherit of $resource

        var Invoice = function (resource, company) {
            // Call the parent constructor
            this.id = null;
            this.invoiceNumber = null;
            this.canNum = null;
            this.creNum = null;
            this.isDeleted = false;
            this.payInId = null;
            this.refundId = null;
            this.company = company;
            this.billingDate = null;
            this.periodStart = null;
            this.periodEnd = null;
            this.paymentDate = null;
            this.status = null;
            this.type = null;
            this.paymentType = null;    //CB CHQ VIR VIRM
            this.paymentFailedMessage = null;
            this.subscriptionLines = [];
            this.subscriptionPrice = null;
            this.discountLines = [];
            this.percentDiscount = null;
            this.subscriptionPriceDiscount = null;
            this.usageBasedLines = [];
            this.usageBasedPrice = null;
            this.totalPrice = null;
            this.vat = null;
            this.vatNumber = null;
            this.totalPriceTTC = null;
            this.alreadyPayed = null;
            this.companyName = null;
            this.headquartersAddress = null;
            this.headquartersAddressLine1 = null;
            this.headquartersPostalCode = null;
            this.headquartersCity = null;
            this.headquartersCountry = null;
            this.legalRepresentativeFirstName = null;
            this.legalRepresentativeLastName = null;
            this.annualSubId = null;

            if (resource !== undefined && resource != null)
                this.loadObjectData(resource);

            InvoiceData.add(this);
        };
        Invoice.prototype.loadObjectData = function (resource) {
            if (resource !== undefined && resource != null) {
                if (!this.id)
                    this.id = resource.id;
                this.invoiceNumber = resource.invoiceNumber;
                this.canNum = resource.canNum;
                this.creNum = resource.creNum;

                this.payInId = resource.payInId;
                this.refundId = resource.refundId;

                if (resource.billingDate)
                    this.billingDate = new Date(resource.billingDate);
                if (resource.periodEnd)
                    this.periodEnd = new Date(resource.periodEnd);
                if (resource.periodStart) {
                    this.periodStart = new Date(resource.periodStart);
                    // TODO fix Period end issue which is not at the end of the month but at the start of next month because timezone issue
                    if (this.periodEnd && resource.annualSubId == null && (this.periodEnd.getDay() == 1 && this.periodEnd.getMonth() == this.periodStart.getMonth() + 1))
                        this.periodEnd = new Date(this.periodStart.getFullYear(), this.periodStart.getMonth() + 1, 0);
                }
                if (resource.paymentDate)
                    this.paymentDate = new Date(resource.paymentDate);

                this.status = resource.status;
                this.type = resource.type;
                this.paymentType = resource.paymentType;
                this.paymentFailedMessage = resource.paymentFailedMessage;
                var invoiceLine;
                if (resource.subscriptionLines)
                    for (var i = 0; i < resource.subscriptionLines.length; i++) {
                        invoiceLine = {
                            label: resource.subscriptionLines[i].label,
                            priceUnit: resource.subscriptionLines[i].priceUnit,
                            unitLabel: resource.subscriptionLines[i].unitLabel,
                            price: resource.subscriptionLines[i].price,
                            quantity: resource.subscriptionLines[i].quantity,
                            percentDiscount: resource.subscriptionLines[i].percentDiscount
                        };
                        this.subscriptionLines.push(invoiceLine);

                    }
                this.subscriptionPrice = resource.subscriptionPrice;
                if (resource.discountLines)
                    for (var i = 0; i < resource.discountLines.length; i++) {
                        invoiceLine = {
                            label: resource.discountLines[i].label,
                            priceUnit: resource.discountLines[i].priceUnit,
                            unitLabel: resource.discountLines[i].unitLabel,
                            price: resource.discountLines[i].price,
                            quantity: resource.discountLines[i].quantity,
                            percentDiscount: resource.discountLines[i].percentDiscount
                        };
                        this.discountLines.push(invoiceLine);

                    }
                this.percentDiscount = resource.percentDiscount;
                ;
                this.subscriptionPriceDiscount = resource.subscriptionPriceDiscount;
                ;
                if (resource.usageBasedLines)
                    for (var i = 0; i < resource.usageBasedLines.length; i++) {
                        invoiceLine = {
                            label: resource.usageBasedLines[i].label,
                            priceUnit: resource.usageBasedLines[i].priceUnit,
                            unitLabel: resource.usageBasedLines[i].unitLabel,
                            price: resource.usageBasedLines[i].price,
                            quantity: resource.usageBasedLines[i].quantity,
                            percentDiscount: resource.usageBasedLines[i].percentDiscount
                        };
                        this.usageBasedLines.push(invoiceLine);

                    }
                this.usageBasedPrice = resource.usageBasedPrice;
                ;
                this.totalPrice = resource.totalPrice;
                this.vat = resource.vat;
                ;
                this.vatNumber = resource.vatNumber;
                ;
                this.totalPriceTTC = resource.totalPriceTTC;
                this.alreadyPayed = resource.alreadyPayed;
                this.companyName = resource.companyName;
                this.headquartersAddress = resource.headquartersAddress;
                this.headquartersAddressLine1 = resource.headquartersAddressLine1;
                this.headquartersPostalCode = resource.headquartersPostalCode;
                this.headquartersCity = resource.headquartersCity;
                this.headquartersCountry = resource.headquartersCountry;
                this.legalRepresentativeFirstName = resource.legalRepresentativeFirstName;
                this.legalRepresentativeLastName = resource.legalRepresentativeLastName;
                this.annualSubId = resource.annualSubId;
            }
        }
        Invoice.prototype.getObjectResource = function () {
            var invoiceRes = new Invoice_Resource();
            invoiceRes.id = this.id;
            if (this.company)
                invoiceRes.companyCode = this.company.code;
            invoiceRes.invoiceNumber = this.invoiceNumber;
            invoiceRes.payInId = this.payInId;
            if (this.billingDate)
                invoiceRes.billingDate = new Date(this.billingDate);
            if (this.periodStart)
                invoiceRes.periodStart = new Date(this.periodStart);
            if (this.periodEnd)
                invoiceRes.periodEnd = new Date(this.periodEnd);
            if (this.paymentDate)
                invoiceRes.paymentDate = new Date(this.paymentDate);
            invoiceRes.status = this.status;
            invoiceRes.type = this.type;
            invoiceRes.paymentType = this.paymentType;
            invoiceRes.paymentFailedMessage = this.paymentFailedMessage;
            var invoiceLine;
            invoiceRes.subscriptionLines = [];
            if (this.subscriptionLines)
                for (var i = 0; i < this.subscriptionLines.length; i++) {
                    invoiceLine = {
                        label: this.subscriptionLines[i].label,
                        priceUnit: this.subscriptionLines[i].priceUnit,
                        unitLabel: this.subscriptionLines[i].unitLabel,
                        price: this.subscriptionLines[i].price,
                        quantity: this.subscriptionLines[i].quantity,
                        percentDiscount: this.subscriptionLines[i].percentDiscount
                    };
                    invoiceRes.subscriptionLines.push(invoiceLine);

                }
            invoiceRes.subscriptionPrice = this.subscriptionPrice;
            invoiceRes.discountLines = [];
            if (this.discountLines)
                for (var i = 0; i < this.discountLines.length; i++) {
                    invoiceLine = {
                        label: this.discountLines[i].label,
                        priceUnit: this.discountLines[i].priceUnit,
                        unitLabel: this.discountLines[i].unitLabel,
                        price: this.discountLines[i].price,
                        quantity: this.discountLines[i].quantity,
                        percentDiscount: this.discountLines[i].percentDiscount
                    };
                    invoiceRes.discountLines.push(invoiceLine);

                }
            invoiceRes.percentDiscount = this.percentDiscount;
            ;
            invoiceRes.subscriptionPriceDiscount = this.subscriptionPriceDiscount;
            ;
            invoiceRes.usageBasedLines = [];
            if (this.usageBasedLines)
                for (var i = 0; i < this.usageBasedLines.length; i++) {
                    invoiceLine = {
                        label: this.usageBasedLines[i].label,
                        priceUnit: this.usageBasedLines[i].priceUnit,
                        unitLabel: this.usageBasedLines[i].unitLabel,
                        price: this.usageBasedLines[i].price,
                        quantity: this.usageBasedLines[i].quantity,
                        percentDiscount: this.usageBasedLines[i].percentDiscount
                    };
                    invoiceRes.usageBasedLines.push(invoiceLine);

                }
            invoiceRes.usageBasedPrice = this.usageBasedPrice;
            ;
            invoiceRes.totalPrice = this.totalPrice;
            invoiceRes.vat = this.vat;
            invoiceRes.vatNumber = this.vatNumber;
            invoiceRes.totalPriceTTC = this.totalPriceTTC;
            invoiceRes.alreadyPayed = this.alreadyPayed;
            invoiceRes.companyName = this.companyName;
            invoiceRes.legalRepresentativeFirstName = this.legalRepresentativeFirstName;
            invoiceRes.legalRepresentativeLastName = this.legalRepresentativeLastName;
            invoiceRes.annualSubId = this.annualSubId;
            //invoiceRes.headquartersAddress = this.headquartersAddress; //Updated by server
            return invoiceRes;
        }

        Invoice.prototype.loadRef = function () {
            this.storeApp = StoreAppData.getById(this._storeAppId);
        }
        return Invoice;
    }
]);

angular.module('FlexyBeautyApp.services').factory('InvoiceSrv', ["$log", "Invoice_Resource", "Invoice", "ServerSrv", "InvoiceData",
    function ($log, Invoice_Resource, Invoice, ServerSrv, InvoiceData) {
        var invoiceSrv = {};
        invoiceSrv.save = function (invoice, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.saveSync, invoice, successFunction, errorFunction);
        };
        invoiceSrv.saveSync = function (invoice, successFunction, errorFunction) {
            var invoiceRes = invoice.getObjectResource();
            invoiceRes.$save({}, //no params
                function (data) {
                    try {
                        if (data)
                            invoice.invoiceNumber = data.invoiceNumber;
                        if (successFunction !== undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };
        invoiceSrv.payIn = function (invoice, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.payInSync, invoice, successFunction, errorFunction);
        };
        invoiceSrv.payInSync = function (invoice, successFunction, errorFunction) {
            var invoiceRes = new Invoice_Resource()
            invoiceRes.id = invoice.id;
            invoiceRes.$payIn({}, //no params
                function (data) {
                    if (data && data.status) {
                        invoice.status = data.status;
                        if (data.status == "paymentFailed" && data.paymentFailedMessage)
                            invoice.paymentFailedMessage = data.paymentFailedMessage;
                        invoice.invoiceNumber = data.invoiceNumber;
                        invoice.paymentDate = data.paymentDate;
                        invoice.payInId = data.payInId;
                    }

                    //Save on server success :
                    // -> add an user action (send message)
                    try {
                        if (successFunction !== undefined)
                            successFunction(invoice);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };
        invoiceSrv.updateVat = function (invoice, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.updateVatSync, invoice, successFunction, errorFunction);
        };
        invoiceSrv.updateVatSync = function (invoice, successFunction, errorFunction) {
            let invoiceRes = invoice.getObjectResource();

            invoiceRes.$updateVat({},
                function (data) {
                    invoice.vat = data.vat;
                    invoice.totalPriceTTC = data.totalPriceTTC;
                    try {
                        if (successFunction !== undefined)
                            successFunction(invoice);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };
        invoiceSrv.globalPayOut = function (successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.globalPayOutSync, successFunction, errorFunction);
        };
        invoiceSrv.globalPayOutSync = function (successFunction, errorFunction) {

            var invoiceRes = new Invoice_Resource()
            invoiceRes.$globalPayOut({}, //no params
                function (data) {
                    try {
                        if (successFunction !== undefined)
                            successFunction();
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

        };
        invoiceSrv.generateInvoiceOnPreviousMonth = function (company, previousMonthNumber, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.generateInvoiceOnPreviousMonthSync, company, previousMonthNumber, successFunction, errorFunction);
        };
        invoiceSrv.generateInvoiceOnPreviousMonthSync = function (company, previousMonthNumber, successFunction, errorFunction) {

            var invoiceRes = new Invoice_Resource();
            invoiceRes.$generateInvoiceOnPreviousMonth({
                    "company-code": company.code,
                    previousMonthNumber: previousMonthNumber,
                }, //no params
                function (data) {
                    var invoice = null;
                    if (data) {
                        invoice = new Invoice(data, company);
                        company.invoices.push(invoice);
                    }

                    //Save on server success :
                    // -> add an user action (send message)
                    try {
                        if (successFunction !== undefined)
                            successFunction(invoice);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        invoiceSrv.generateEstimateInvoice = function (company, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.generateEstimateInvoiceSync, company, successFunction, errorFunction);
        };

        invoiceSrv.generateEstimateInvoiceSync = function (company, successFunction, errorFunction) {
            let invoiceResource = new Invoice_Resource();
            invoiceResource.$generateEstimateInvoice({},
                function (data) {
                    try {
                        company.loadEstimateInvoices(data);
                        if (successFunction !== undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, data.status);
                    }
                }
            );
        };

        invoiceSrv.proceedPayment = function (invoice, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.proceedPaymentSync, invoice, successFunction, errorFunction);
        };
        invoiceSrv.proceedPaymentSync = function (invoice, successFunction, errorFunction) {

            var invoiceRes = invoice.getObjectResource();
            invoiceRes.$proceedPayment({}, //no params
                function (data) {
                    try {
                        if (data.status === "paymentFailed" && errorFunction !== undefined) {
                            errorFunction(data);
                        } else if (data.status !== "paymentFailed" && successFunction !== undefined) {
                            successFunction(data);
                        } else {
                            $window.location.reload(true);
                        }
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

        };
        invoiceSrv.remove = function (invoice, successFunction, errorFunction) {
            InvoiceData.remove(invoice);
            ServerSrv.startSavingProcess(invoiceSrv.removeSync, invoice, successFunction, errorFunction);
        };
        invoiceSrv.removeSync = function (invoice, successFunction, errorFunction) {
            var invoiceRes = new Invoice_Resource();
            invoiceRes.$remove({id: invoice.id}, //no params
                function (data) {
                    try {
                        if (successFunction !== undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

        };
        invoiceSrv.cancel = function (invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(invoiceSrv.cancelSync, invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction);
        };
        invoiceSrv.cancelSync = function (invoice, isRefundInvoice, isNewInvoice, successFunction, errorFunction) {

            var invoiceCancelRes = new Invoice_Resource();
            invoiceCancelRes.invoice = invoice.getObjectResource();
            invoiceCancelRes.refundInvoice = isRefundInvoice;
            invoiceCancelRes.newInvoice = isNewInvoice;

            invoiceCancelRes.$cancel({}, //no params
                function (data) {
                    try {
                        // generate new invoice
                        var creditInvoice = null;
                        if (data && data.invoice) {
                            invoice.status = data.invoice.status;
                            invoice.creNum = data.invoice.creNum;
                            invoice.refundId = data.invoice.refundId;
                        }
                        if (data && data.creditInvoice)
                            creditInvoice = new Invoice(data.creditInvoice);
                        var newInvoice = null;
                        if (data && data.newInvoice)
                            newInvoice = new Invoice(data.newInvoice);

                        if (successFunction !== undefined)
                            successFunction(invoice, creditInvoice, newInvoice);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try {
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

        };
        return invoiceSrv;
    }
]);

angular.module('FlexyBeautyApp.services').factory('InvoiceData', ["$log", "$filter", function ($log, $filter) {
    var invoiceDataSrv =
        {
            indexInvoices: [],
            activeInvoices: [],
            deletedInvoices: []//deleted items
        };
    invoiceDataSrv.getById = function (invoiceId) {
        for (var i = 0; i < this.indexInvoices.length; i++)
            if (this.indexInvoices[i].getId() == invoiceId)
                return this.indexInvoices[i];
        return null;
    }
    invoiceDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexInvoices.length)
            return this.indexInvoices[index];
        return null;
    }
    invoiceDataSrv.getIndexOf = function (invoice) {
        if (invoice)
            return this.indexInvoices.indexOf(invoice);
        return -1;
    }

    invoiceDataSrv.add = function (invoice) {
        var invoiceArray = this.activeInvoices;
        if (invoice.isDeleted)
            invoiceArray = this.deletedInvoices;
        var index = this.indexInvoices.indexOf(invoice);
        if (index != -1) {
            var realIndex = invoiceArray.indexOf(invoice);
            if (realIndex == -1)
                invoiceArray.push(invoice);
        } else {
            index = this.indexInvoices.length
            this.indexInvoices.push(invoice);
            invoiceArray.push(invoice);
        }
        return index;
    }
    invoiceDataSrv.remove = function (invoice) {
        var index = this.activeInvoices.indexOf(invoice);
        if (index != -1) {
            this.activeInvoices.splice(index, 1);
            this.deletedInvoices.push(invoice)
            invoice.isDeleted = true;
        }
    }
    invoiceDataSrv.restore = function (invoice) {
        var index = this.deletedInvoices.indexOf(invoice);
        if (index != -1) {
            this.deletedInvoices.splice(index, 1);
            this.activeInvoices.push(invoice);
            invoice.isDeleted = false;
        }
    }
    invoiceDataSrv.clear = function () {
        this.indexInvoices = [];
        this.activeInvoices = [];
        this.deletedInvoices = [];
    }
    invoiceDataSrv.sort = function () {
        this.activeInvoices = $filter('orderBy')(this.activeInvoices, 'billingDate', false);
        this.deletedInvoices = $filter('orderBy')(this.deletedInvoices, 'billingDate', false);
    }

    invoiceDataSrv.getActiveList = function () {
        return this.activeInvoices;
    }
    invoiceDataSrv.getDeletedList = function () {
        return this.deletedInvoices;
    }
    return invoiceDataSrv;

    return invoiceDataSrv;
}]);




// WEBPACK FOOTER //
// ./js/services/models/Invoice.js